module.exports = __webpack_public_path__ + "media/images/products/retailers-og-3-be61121f7ed22ab6b85af22dc8cac2d7.jpg";